module.exports = __webpack_public_path__ + "static/media/left-arrow.e5e59c42.svg";